var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12"}},_vm._l((_vm.messages),function(item,index){return _c('v-alert',{key:index,attrs:{"type":"info","text":""}},[_vm._v(_vm._s(item.message))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }